/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import LegacyGrid from './legacy/LegacyGrid';
import { withStyles } from '@mui/styles';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { categories, Category } from '../common/Categories';
import { isRoleExists, sendRequestAndReceiveResponse } from '../common/common';
import { getPresignMultipleDownloads } from '../common/constants';
import { actionCreators } from '../store/ViewDownloads';
import DownloadDataTable from './DownloadDataTable';
import EditDownloads from './EditDownloads';
import ProductClassification from './ProductClassification';
import SerialNumberSearch from './SerialNumberSearch';
import UploadDownloads from './UploadDownloads';

const styles = () => ({
    selectInput: {
        backgroundColor: '#fff',
        borderRadius: 0,
        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.2)',
        '& em': {
            fontSize: 14,
            fontStyle: 'normal'
        }
    },
    dropdown: {
        fontSize: 14,
        fontStyle: 'normal',
        marginLeft: 10
    }
});

interface Props {
    downloadsData: any
    selectedFamily: any
    selectedProductName: any
    selectedProductModel: any
    families: any
    productModels: any
    productNames: any
    serialNumber: any
    isDownloadsLoading: any
    loadingDownloadDetail: any
    selectedDownload: any
    selectedDownloadIds: []

    LoadDownload: Function
    UpdateSerialNumber: Function
    StopLoading: Function
    ClearViewDownloadsData: Function,
    ClearDownloadsList: Function
    UpdateProductFamilies: Function
    UpdateSelectedFamily: Function,
    UpdateSelectedProductName: Function
    UpdateSelectedProductModel: Function
    FilterNames: Function
    FilterModels: Function
    UpdateProductClassificationonSerialNumber: Function
}

interface State {
    currentUrl: any,
    selectedfilterValue: any
}

const ProductFamily = 'selectedFamily';
const ProductName = 'selectedProductName';
const ProductModel = 'selectedProductModel';

class Downloads extends React.Component<Props, State> {
    async componentDidMount() {
        this.props.ClearViewDownloadsData();
    }
    handleSerialNumberSearch = async (twoDproductFamilyid: any, twoDproductNameid: any, twodModelid: any, downloads: any) => {
        await this.props.FilterNames(this.props.families, twoDproductFamilyid);
        await this.props.FilterModels(this.props.productNames, twoDproductNameid);
        await this.props.UpdateProductClassificationonSerialNumber(twoDproductFamilyid,
            twoDproductNameid,
            twodModelid,
            downloads);
    };
    LoadDownload = (data: any) => {
        this.props.LoadDownload(data);
    };
    handleDownloads = async () => {
        const urls = await sendRequestAndReceiveResponse(JSON.stringify({ 'downloadsList': this.props.selectedDownloadIds }), getPresignMultipleDownloads);
        for (const element of urls.downloadPresignedURLList) {
            window.open(element.presignedURL);
        }
    };
    UpdateSerialNumber = (data: any) => {
        this.props.UpdateSerialNumber(data);
    };
    StopLoading = () => {
        this.props.StopLoading();
    };
    ClearAll = () => {
        this.props.ClearDownloadsList();
    };
    UpdateProductFamilies = (data: any) => {
        this.props.UpdateProductFamilies(data);
    };
    handleDownloadClassificationChange = (event: any) => {
        if (event.target.value !== '') {
            switch (event.target.name) {
                case ProductFamily:
                    this.props.UpdateSelectedFamily([event.target.value]);
                    this.props.FilterNames(this.props.families, [event.target.value]);
                    break;
                case ProductName:
                    this.props.UpdateSelectedProductName([event.target.value]);
                    this.props.FilterModels(this.props.productNames, [event.target.value]);
                    break;
                case ProductModel:
                    this.props.UpdateSelectedProductModel([event.target.value]);
                    break;
            }
        }
    };

    handleRedirections = () => {
        if (this.props.selectedProductModel != null && this.props.selectedProductModel !== undefined) {
            this.props.UpdateSelectedProductModel(this.props.selectedProductModel);
        }
        else if (this.props.selectedProductName != null && this.props.selectedProductName !== undefined) {
            this.props.UpdateSelectedProductName(this.props.selectedProductName);
        }
        else if (this.props.selectedFamily != null && this.props.selectedFamily !== undefined) {
            this.props.UpdateSelectedFamily(this.props.selectedFamily);
        }
    };

    render() {
        const selectedCategory: Category | undefined = categories.find(
            (category: Category) => {
                return category.id === 16;
            }
        );

        return (
            <LegacyGrid>
                <LegacyGrid container justifyContent="space-between">
                    <SerialNumberSearch
                        isBulletin={false}
                        isDownloads={true}
                        isLaborTimeGuide={false}
                        isInstrumentConstants={false}
                        handleSerialNumberSearch={this.handleSerialNumberSearch}
                        LoadServiceManual={this.LoadDownload}
                        UpdateSerialNumber={this.UpdateSerialNumber}
                        StopLoading={this.StopLoading}
                        selectedFamily={this.props.selectedFamily}
                        selectedProductName={this.props.selectedProductName}
                        selectedProductModel={this.props.selectedProductModel}
                        productModels={this.props.productModels}
                        families={this.props.families}
                        productNames={this.props.productNames}
                        isLoading={this.props.isDownloadsLoading}
                        serialNumber={this.props.serialNumber}
                        ClearAll={this.ClearAll} />
                    or
                    <ProductClassification families={this.props.families} selectedFamily={this.props.selectedFamily} selectedProductName={this.props.selectedProductName}
                        selectedProductModel={this.props.selectedProductModel}
                        productModels={this.props.productModels} productNames={this.props.productNames}
                        handleManualClassificationChange={this.handleDownloadClassificationChange} isLoading={this.props.isDownloadsLoading}
                        UpdateProductFamilies={this.UpdateProductFamilies} />
                    <div>
                        {isRoleExists(4) && <UploadDownloads handleRedirection={this.handleRedirections} />}
                    </div>
                </LegacyGrid>
                <LegacyGrid container className="downloadEdit font14">
                    <LegacyGrid item xs={11}></LegacyGrid>
                    <LegacyGrid item xs={1}>
                        <LegacyGrid container>
                            <LegacyGrid item xs={6}> </LegacyGrid>
                            <LegacyGrid item xs={3}>
                                {isRoleExists(4) && <EditDownloads enabled={this.props.selectedDownload} />}
                            </LegacyGrid>
                            <LegacyGrid item xs={3}>
                                {
                                    <div>
                                        <FileDownloadOutlinedIcon id="download-button" onClick={this.handleDownloads}
                                            className={this.props.selectedDownloadIds && this.props.selectedDownloadIds.length > 0 ?
                                                'editColor' : 'disabledColor'} style={{ cursor: 'pointer', fontSize: '1.8rem' }} />
                                    </div>
                                }
                            </LegacyGrid>
                        </LegacyGrid>
                    </LegacyGrid>
                </LegacyGrid>
                <DownloadDataTable selectedCategory={selectedCategory} gridData={this.props.downloadsData} />
            </LegacyGrid>
        );
    }
}

const mapStateToProps = (state: any) => ({
    state: state.viewDownloads,
    data: state.viewDownloads.data,
    downloadsData: state.viewDownloads.downloadsData,
    selectedFamily: state.viewDownloads.selectedFamily,
    selectedProductName: state.viewDownloads.selectedProductName,
    selectedProductModel: state.viewDownloads.selectedProductModel,
    isDownloadsLoading: state.viewDownloads.isDownloadsLoading,
    loadingDownloadDetail: state.viewDownloads.loadingDownloadDetail,
    selectedDownload: state.viewDownloads.selectedDownload,
    selectedDownloadIds: state.viewDownloads.selectedDownloadIds,
    serialNumber: state.viewDownloads.serialNumber,
    families: state.viewDownloads.families,
    productModels: state.viewDownloads.productModels,
    productNames: state.viewDownloads.productNames,
});

const mapDispatchtoProps = (dispatch: any) =>
    bindActionCreators(actionCreators, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchtoProps
)((withStyles(styles as any)(Downloads)));
